const IconoANSES = ({ size = 36, color = 'currentColor' }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 100"
        width={size}
        height={size}
        fill="none"
        stroke={color}
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        {/* Cuerpo del documento con esquina doblada */}
        <path d="M18,5 L68,5 L83,22 L83,95 L18,95 Z" />
        {/* Pliegue de la esquina */}
        <polyline points="68,5 68,22 83,22" />
        {/* Líneas de texto */}
        <line x1="30" y1="42" x2="71" y2="42" />
        <line x1="30" y1="55" x2="71" y2="55" />
        <line x1="30" y1="68" x2="71" y2="68" />
        <line x1="30" y1="81" x2="71" y2="81" />
        <line x1="30" y1="90" x2="55" y2="90" />
    </svg>
);

export default IconoANSES;
